<template>
  <div id="calendar" class="calendar">
    <component
      :is="this.$route.name === 'embed' ? 'EmbedConfirmation' : 'Confirmation'"
      v-if="showConfirmation"
      @resetBooking="
        showConfirmation = false;
        $store.commit('setSelectedBooking', '');
        selectedGuests = 0;
        currentGuestInfo = undefined;
        firstName='';
        lastName='';
        emailAddress='';
        phoneNumber='';
        notes=''
      "
      :response="bookingResponse"
    />
    <div v-else :class="{'date-not-chosen': $store.state.availableBookings.length === 0}">
      <div>
        <h2><span>&bull;</span> Select Date</h2>
        <div class="holder">
          <div class="ui">
            <ArrowButton @click="changeMonth(-1)" />
            <h3>{{ month }}</h3>
            <ArrowButton next @click="changeMonth(1)" />
          </div>
          <div class="days">
            <div>S</div>
            <div>M</div>
            <div>T</div>
            <div>W</div>
            <div>T</div>
            <div>F</div>
            <div>S</div>
          </div>
          <div class="month">
            <Day
              v-for="day in content"              
              :date="day.date"
              :day="day.day"
              :disabled="day.disabled"
            />
          </div>
        </div>
      </div>
      <div
        v-show="$store.state.availableBookings.length !== 0"
        id="available-times"
      >
        <transition name="fade" appear>
          <div>
            <h2><span>&bull;</span> Select Time</h2>
            <AvailableTimes />
          </div>
        </transition>
      </div>
      <div id="form" class="details" v-if="$store.state.selectedBooking !== ''" :class="{'show-errors':showErrors}">
        <transition name="fade" appear>
          <div>
            <h2><span>&bull;</span> Enter Details</h2>
            <div class="holder" style="min-width:300px">
              <table>
                <tr>
                  <td class='label-holder'><span class="label">*First Name</span></td>
                  <td>
                    <input
                      :class="firstName !== '' ? 'has-value' : 'has-error'"
                      type="text"
                      name="firstname"
                      id="firstname"
                      v-model="firstName"
                    />
                  </td>
                </tr>
                <tr>
                  <td class='label-holder'><span class="label">*Last Name</span></td>
                  <td>
                    <input
                      :class="lastName !== '' ? 'has-value' : 'has-error'"
                      type="text"
                      name="lastname"
                      id="lastname"
                      v-model="lastName"
                    />
                  </td>
                </tr>
                <tr>
                  <td class='label-holder'><span class="label">*Email Address</span></td>
                  <td>
                    <input
                      :class="[
                        emailAddress !== '' ? 'has-value' : '',
                        emailAddress !== '' && testEmail.test(emailAddress)
                          ? ''
                          : 'has-error',
                      ]"
                      type="email"
                      name="email"
                      id="email"
                      v-model="emailAddress"
                    />
                  </td>
                </tr>
                 <tr>
                  <td class='label-holder'><span class="label">Company</span></td>
                  <td>
                    <input
                      type="text"
                      name="company"
                      id="company"
                      v-model="company"
                    />
                  </td>
                </tr>
                <tr>
                  <td class='label-holder'><span class="label">Phone Number</span></td>
                  <td>
                    <input
                      :class="[
                        phoneNumber !== '' &&
                        phoneNumber.replace(/\D/g, '').length < 10
                          ? 'has-error'
                          : '',
                      ]"
                      type="tel"
                      name="phonenumber"
                      id="phonenumber"
                      v-model="phoneNumber"
                    />
                  </td>
                </tr>      
                <tr>
                  <td class='label-holder'><span class="label">Meeting Preference</span></td>
                  <td class='has-select'>
                    <select name="preference" id="preference" v-model="preference">
                      <option value=""></option>
                      <option value="Phone">Phone</option>
                      <option value="Virtual">Virtual</option>
                    </select>
                  </td>
                </tr>   
                <tr style="display:none">
                  <td class='label-holder'><span class="label">Notes</span></td>
                  <td><input type="text" name="notes" id="notes" v-model="notes"/></td>
                </tr>                          
              </table>                            
              <Button
                text="Request Meeting"
                style="width:100%;"
                link=""                
                
                @click="submitAppointment"
                class="submit"
                :class="{ disabled: errorsInForm }"
              />
            </div>
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { format, add } from "date-fns";
import ArrowButton from "@/components/ArrowButton";
import GuestButton from "@/components/GuestButton";
import Button from "@/components/Button";
import AvailableTimes from "@/components/AvailableTimes";
import GuestModal from "@/components/GuestModal";
import Day from "@/components/Day";
import Confirmation from "@/components/Confirmation";
import EmbedConfirmation from "@/components/EmbedConfirmation";
export default {
  name: "Form",
  created() {
    this.now = new Date();
    this.getMonth();
  },
  data() {
    return {
      month: "",
      content: "",
      now: undefined,
      selectedGuests: 0,
      showGuestsModal: false,
      currentGuestInfo: undefined,
      showConfirmation: false,
      testEmail: /^.+@.+\..+$/,
      showErrors:false,
      firstName: "",
      lastName: "",
      emailAddress: "",
      company: "",
      phoneNumber: "",
      notes: "",
      preference: "",
      bookingResponse:{},      
    };
  },
  components: {
    Button,
    ArrowButton,
    Day,
    AvailableTimes,
    GuestButton,
    GuestModal,
    Confirmation,
    EmbedConfirmation
  },
  computed: {
    errorsInForm() {
      let errors = [];
      this.firstName !== "" ? "" : errors.push("first-name");
      this.lastName !== "" ? "" : errors.push("last-name");
      this.emailAddress !== "" && this.testEmail.test(this.emailAddress)
        ? ""
        : errors.push("email-address");
      //this.phoneNumber !== "" ? "" : errors.push("phone-number");
      this.phoneNumber !== "" && this.phoneNumber.replace(/\D/g, "").length < 10
        ? errors.push("phone-number")
        : "";
      return errors.length > 0;
    },
  },
  methods: {
    submitAppointment() {
      if (this.errorsInForm) {
        this.showErrors = true;
        return;
      }         
      this.showGuestsModal = false
      const params = new URLSearchParams();
      params.append("appointment", this.$store.state.selectedBooking);
      params.append("first", this.firstName.trim());
      params.append("last", this.lastName.trim());
      params.append("email", this.emailAddress.trim());
      params.append("phone", this.phoneNumber.trim().replace(/\D/g, ''));
      params.append("company", this.company.trim());
      
      if(this.preference !== '') {
        params.append("notes", `Meeting Preference: ${this.preference}`);
      } else {
        params.append("notes", "");
      }

      params.append("guests", this.selectedGuests);
      
      if(this.selectedGuests > 0) {
        this.currentGuestInfo.forEach((element, id) => {
          params.append(`guestDetails[${id}][first]`, element.first);
          params.append(`guestDetails[${id}][last]`, element.last);
          params.append(`guestDetails[${id}][email]`, element.email);
          //guestDetails[0][first]: gf
          //guestDetails[0][last]: gl
          //guestDetails[0][email]: richard@channel1media.com
        });
        
      }

      params.append("display", '');
      params.append("address", '');
      params.append("purl", this.$route.params.purl);      
      params.append("schedule", this.$store.state.selectedSchedule);
      axios
        .post(`${this.$store.state.API}/Appointment.php`, params)
        .then(this.onSubmitAppointment);
        
    },
    onSubmitAppointment(response) {
      if (response.data.status == "ok") {
        this.showConfirmation = true;
        this.bookingResponse = response.data;
      } else {
        alert("An error occurred getting the month");
      }
    },
    setGuests(guests) {
      this.selectedGuests = guests.length;
      this.currentGuestInfo = guests;
    },
    changeMonth(months) {
      this.now = add(this.now, { months: months });
      this.getMonth();
    },
    getMonth() {
      const params = new URLSearchParams();
      params.append("month", format(this.now, "M"));
      params.append("year", format(this.now, "yyyy"));
      params.append("schedule", this.$store.state.selectedSchedule);
      axios
        .post(`${this.$store.state.API}/Calendar.php`, params)
        .then(this.onGetCalendar);
    },
    onGetCalendar(response) {
      if (response.data.status == "ok") {
        this.month = response.data.month;
        this.content = response.data["json-content"];
      } else {
        alert("An error occurred getting the month");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.submit {
  position: relative;
  &:after {
    content: "fill in required fields to proceed";
    background: var(--dark-grey);
    opacity: 0;
    position: absolute;
    top:0;
    left:0;
    width:100%;
    height:100%;
    display:grid;
    place-items: center;
    color:var(--dark-red);
  }
  &.disabled {
    opacity: 0.3;
    border: 1px solid var(--accent);
    overflow:hidden;
    &:hover{
      opacity: 1;
      &:after {
        opacity: 1;
      }
    }
  }  
}
table {
  border-collapse: separate;
  border-spacing: 0 10px;
  table-layout: fixed;
}
table {
  color: var(--white);
  text-align: left;
  width: 100%;

  td {
    white-space: nowrap;
  }
  span {
    padding: 5px;
    padding-left: 0;
    font-size: 1rem;
    font-family: 'Alternate Gothic No3 D';
  }
  .label-holder {
    width:130px;
  }
  .has-select, input {
    padding: 10px 15px;
    width: 100%;
    box-sizing: border-box;
    font-family: 'Alternate Gothic No3 D';
    background: rgba(255,255,255,0.08);
    border-radius: 54px;
    border:none;
    color:var(--ao-black);
    font-size: 1rem;
  }
  .has-select {
    padding-right:1rem;
  }
  select {
    background:none;
    border:none;
    width: 100%;
    outline:none;
    color:#FFF;
    font-family: 'Alternate Gothic No3 D';
    font-size: 1rem;
  }
  input {
    padding: 10px 15px;
    width: 100%;
    box-sizing: border-box;
    font-family: 'Alternate Gothic No3 D';
    background: rgba(255,255,255,0.08);
    border-radius: 54px;
    border:none;
    color:#FFF;
    font-size: 1rem;
  }
  .guests td {
    padding: 20px 0;
  }
  .guest-options {
    display: flex;
    gap: 5px;
    flex-wrap: wrap;
    justify-content: space-between;
    button {
      height: 30px;
      width: 30px;
    }
  }
}
.details {
  flex-grow: 1;
  > div > div {
    padding: 10px;
  }
  &.show-errors .has-error {
    background:var(--dark-grey);
    border:1px solid var(--accent);
    color:var(--white);
  }
}
.holder {
  padding: 20px 30px;
  box-sizing: border-box;
  min-width:410px;
}
h2 {
  background: linear-gradient(126.38deg, #AC604E 2.67%, #AC604E 16.35%, #EAA482 35.87%, #F4B598 47.97%, #D48B63 68.31%, #E49B79 83.79%);    
  color: var(--black);
  text-align: left;
  padding: 20px 12px;
  margin: 0;
  font-size: 1.25rem;
  text-transform: uppercase;
  font-family: 'Alternate Gothic No3 D';  
}
h3 {
  color: var(--white);
  font-size: 1rem;
  text-transform: uppercase;
}
.ui {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 5px 20px;
}
#calendar {
  background: linear-gradient(126.38deg, #AC604E 2.67%, #AC604E 16.35%, #EAA482 35.87%, #F4B598 47.97%, #D48B63 68.31%, #E49B79 83.79%);  
  > div {
    background: var(--dark-grey);
    box-shadow: 0 2px 4px 0 rgba(0,0,0,0.50);
    border-radius: 6px;
    overflow:hidden;
    max-width: 500px;
    margin: 25px auto;
    > div:first-child {
      background: var(--grey);    
      h2 {
background: var(--dark-grey);
  color: var(--white);
      }  
    }
    @media (min-width: 1110px) {
      display: flex;
      max-width: 1110px;      
      margin: 100px auto;
      &.date-not-chosen {
        display:block;
        width:450px;
      }
      > div {
        position: relative;        
        &:after {
          content: "";
          height: 6px;
          background: var(--accent);
          position: absolute;
          bottom: 0;
          left: 0;
          width: 0;
          transition: width 0.2s ease-in-out;
        }
      }
    }
  }
}
.days,
.month {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  place-items: center;
}
.days {
  border-radius: 500px;
  color: var(--white);
  padding: 10px 0;
  background: rgba(0,0,0,0.3);
  font-size:0.75rem;
}
.month {
  padding: 15px 0;
}
</style>